// 홈(랜딩) — 바닐라 dcf.html #page-home 이식: 히어로 + 기능 4카드 + 6단계 + 문의.
// 바닐라와 달리 본문도 3개 언어 i18n (EN/JP 전환 시 한국어 잔존 제거 — 사용자 피드백).
import { useT } from "../../lib/i18n";

interface Props {
  onNew: () => void;
  onProjects: () => void;
}

// lucide 원본 패스 — folder-kanban / bar-chart-3 / grid-3x3 / file-text
const FEATURE_ICONS: React.ReactNode[] = [
  <svg key="f1" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z" />
    <path d="M8 10v4" /><path d="M12 10v2" /><path d="M16 10v6" />
  </svg>,
  <svg key="f2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 3v18h18" /><path d="M18 17V9" /><path d="M13 17V5" /><path d="M8 17v-3" />
  </svg>,
  <svg key="f3" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect width="18" height="18" x="3" y="3" rx="2" />
    <path d="M3 9h18" /><path d="M3 15h18" /><path d="M9 3v18" /><path d="M15 3v18" />
  </svg>,
  <svg key="f4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
    <path d="M14 2v4a2 2 0 0 0 2 2h4" />
    <path d="M10 9H8" /><path d="M16 13H8" /><path d="M16 17H8" />
  </svg>,
];

export default function DcfHome({ onNew, onProjects }: Props) {
  const { t } = useT();
  const features = [1, 2, 3, 4].map((i) => ({
    icon: FEATURE_ICONS[i - 1],
    title: t(`home.f${i}t`),
    desc: t(`home.f${i}d`),
  }));
  const steps = [1, 2, 3, 4, 5, 6].map((i) => t(`home.s${i}`));

  return (
    <>
      <section className="hero">
        <div className="hero-inner">
          <div>
            <div className="hero-label">DeepSearch · DCF Valuation Engine</div>
            <h1>
              {t("home.h1a")}
              <br />
              <span>DCF Valuation</span>
            </h1>
            <p>{t("home.p")}</p>
            <div className="hero-btns">
              <button className="btn-primary" onClick={onNew}>{t("home.btn_new")}</button>
              <button className="btn-outline" onClick={onProjects}>{t("home.btn_projects")}</button>
            </div>
          </div>
          <div className="hero-preview">
            <div className="preview-card">
              <div className="preview-card-label">Valuation Result</div>
              <div className="preview-kpi">
                <div><div className="preview-kpi-label">Operating Value</div><div className="preview-kpi-value">61,266{t("home.mn")}</div></div>
                <div><div className="preview-kpi-label">Equity Value</div><div className="preview-kpi-value">60,766{t("home.mn")}</div></div>
                <div><div className="preview-kpi-label">Price / Share</div><div className="preview-kpi-value">30,383{t("home.won")}</div></div>
                <div><div className="preview-kpi-label">TV / EV</div><div className="preview-kpi-value">74.7%</div></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="features">
        <div className="section-title">{t("home.feat_title")}</div>
        <div className="section-sub">{t("home.feat_sub")}</div>
        <div className="feature-grid">
          {features.map((f, i) => (
            <div className="feature-card" key={i}>
              <div className="feature-icon">{f.icon}</div>
              <h3>{f.title}</h3>
              <p>{f.desc}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="steps-section">
        <div className="steps-inner">
          <div className="steps-title">{t("home.steps_title")}</div>
          <div className="steps-sub">{t("home.steps_sub")}</div>
          <div className="steps">
            {steps.map((s, i) => (
              <div className="step" key={i}>
                <div className="step-num">{i + 1}</div>
                <div className="step-label">{s}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <div className="home-contact">
        <span>{t("lbl.contact_email")}</span>
        <a href="mailto:valuation@deepsearch.com">valuation@deepsearch.com</a>
      </div>
    </>
  );
}
